import { gql } from '@apollo/client';

import {
  TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT,
} from '../../../../../../core/graphql/tags';

export const NOTE_TAG_HIGHLIGHTS_FRAGMENT = gql`
  fragment NoteTagHighlights on TestSessionNote {
    tagHighlights {
      ...TagHighlightWithTag
    }
  }
  ${TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT}
`;

export const TEST_SESSION_NOTE = gql`
  query TestSessionNote ($id: ID!) {
    testSessionNote(id: $id) {
      id
      videoUrl
      status
      note
      testSession {
        id
        tester {
          id
          user {
            id
            profile {
              id
              firstName
            }
          }
          project {
            id
            name
          }
        }
      }
      ...NoteTagHighlights
    }
  }
  ${NOTE_TAG_HIGHLIGHTS_FRAGMENT}
`;
